import React from 'react'
import { select } from 'd3'
import { D3Context } from 'src/contexts'

/**
 * A wrapper between React and D3 : Obtain a react ref and a custom hook to manipulate its associated D3 selection
 *
 * @returns {[
 *  import('react').MutableRefObject,
 *  Function,
 * ]} - The react ref along a custom hook to manipulate its associated D3 selection
 */
export default function useD3Selection() {
  // create node ref
  const ref = React.useRef()

  // get transition duration accessor
  const { getTransitionDuration } = D3Context.use()

  // create selection state
  const [selection, setSelection] = React.useState()

  // store selection on mount and remove it on unmount
  React.useEffect(() => {
    setSelection(select(ref.current))
    return () => setSelection()
  }, [])

  return [
    // return ref
    ref,
    // and provide a callback executing a custom useEffect hook with current selection as first parameter
    (effect, deps = []) =>
      // if no dependency array is provided, force apply the effect by incrementing count

      // eslint-disable-next-line react-hooks/rules-of-hooks
      React.useEffect(
        () => {
          if (selection) {
            return effect(
              getTransitionDuration && getTransitionDuration()
                ? selection.transition().duration(getTransitionDuration())
                : selection
            )
          }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [selection, ...deps]
      ),
  ]
}
